import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { get } from "../../lib/sessionClient";
import { PAYLOAD, UUID_URL } from "../../api/allApi_List";
import DialogBox from "../../components/UI/DialogBox";
import LoadingDisplay from "../../components/UI/LoadingDisplay";

export default function AuthGate() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState("");

  const loadPayload = async () => {
    try {
      const [uuidRes, payloadRes] = await Promise.all([
        get(UUID_URL),
        get(PAYLOAD),
      ]);

      const user = payloadRes.data.userData;

      localStorage.setItem("uuid", uuidRes.data.uuid);
      localStorage.setItem("userId", user.id);
      localStorage.setItem("userName", user.fullName);
      localStorage.setItem("perms", payloadRes.data.claims.permissions);
      localStorage.setItem("roles", payloadRes.data.claims.role);
      localStorage.setItem(
        "access_token_time",
        payloadRes.data.claims.access_token_issued_at_utc_tz,
      );

      const pic = Array.isArray(user.profilePicUrlList)
        ? user.profilePicUrlList[0] || ""
        : "";
      localStorage.setItem("profilePic", pic);

      setReady(true);
    } catch (error) {
      if (error.response?.status === 401) {
        navigate("/login");
      } else {
        setError(error.response?.data?.message || error.message);
      }
    }
  };

  useEffect(() => {
    const hasPayload =
      localStorage.getItem("uuid") &&
      localStorage.getItem("userId") &&
      localStorage.getItem("userName") &&
      localStorage.getItem("perms") &&
      localStorage.getItem("roles") &&
      localStorage.getItem("access_token_time");

    if (!hasPayload) {
      loadPayload(); // fetch payload only once globally
    } else {
      setReady(true);
    }
  }, []);

  if (!ready && !error) {
    return <LoadingDisplay />;
  }

  if (error) {
    return (
      <DialogBox
        title="Error"
        message={error}
        isErrorHandleButtons={true}
        isHome={true}
      />
    );
  }

  return <Outlet />; // authenticated app
}
